const translations = {
  en: {
    translation: {
      previous: "Previous",
      next: "Next",
      go_back: "Go back",
      abilities: "Abilities",
      es: "Spanish",
      de: "German",
      en: "English",
      it: "Italian",
      fr: "French",
      hp: "HP",
      attack: "Attack",
      defense: "Defense",
      special_attack: "Special Attack",
      special_defense: "Special Defense",
      speed: "Speed",
      generic_error: "Ooops! An error has occured. Please, reload this page."
    },
  },
  es: {
    translation: {
      previous: "Anterior",
      next: "Siguiente",
      go_back: "Volver",
      abilities: "Habilidades",
      es: "Español",
      de: "Alemán",
      en: "Inglés",
      it: "Italiano",
      fr: "Francés",
      hp: "PS",
      attack: "Ataque",
      defense: "Defensa",
      special_attack: "Ataque Especial",
      special_defense: "Defensa Especial",
      speed: "Velocidad",
      generic_error: "Ooops! Ha ocurrido un error. Por favor, recarga la página."
    },
  },
  fr: {
    translation: {
      previous: "Précédent",
      next: "Suivant",
      go_back: "Revenir",
      abilities: "Capacités",
      es: "Espagnol",
      de: "Allemand",
      en: "Anglais",
      it: "italien",
      fr: "Français",
      hp: "PV",
      attack: "Attaque",
      defense: "Défense",
      special_attack: "Attaque Spéciale",
      special_defense: "Défense Spéciale",
      speed: "Vitesse",
      generic_error: "Oups! Une erreur s'est produite. Veuillez recharger la page."
    },
  },
  de: {
    translation: {
      previous: "Zurückfahren",
      next: "Nächste",
      go_back: "Wiederkehren",
      abilities: "Fähigkeiten",
      es: "Spanisch",
      de: "Deutsch",
      en: "Englisch",
      it: "Italienisch",
      fr: "Französisch",
      hp: "KP",
      attack: "Angriff",
      defense: "Verteidigung",
      special_attack: "Spezialangriff",
      special_defense: "Spezialverteidigung",
      speed: "Initiative",
      generic_error: "Ups! Ein Fehler ist aufgetreten. Bitte laden Sie die Seite neu."
    },
  },
  it: {
    translation: {
      previous: "Indietro",
      next: "Avanti",
      go_back: "Ritorno",
      abilities: "Abilità",
      es: "spagnolo",
      de: "Tedesco",
      en: "Inglese",
      it: "italiano",
      fr: "Francese",
      hp: "PS",
      attack: "Attacco",
      defense: "Difesa",
      special_attack: "Attacco Speciale",
      special_defense: "Difesa Speciale",
      speed: "Velocità",
      generic_error: "Spiacenti! Si è verificato un errore. Per favor, ricarica la pagina."
    },
  },
};

export default translations;
